import { useAuthService } from '~/features/auth/service';

export function errorHandler(config: any, moduleName: string = 'unknown') {
  if (import.meta.server) return;

  const { $logger } = useNuxtApp();
  const authService = useAuthService();
  const log = $logger.withScope(`🚨 ${moduleName} error-handler`);

  if (config.response) {
    // Запрос был сделан, и сервер ответил кодом состояния
    // который выходит за пределы диапазона 2xx
    const {
      message,
      response: { status: code },
    } = config;

    switch (code) {
      case 401:
      case 403:
        authService.logout();
        break;
      default:
        log.error(`error at response`, message);
        break;
    }
  } else if (config.request) {
    // Запрос был сделан, но ответ не получен
    // `error.request` — это экземпляр XMLHttpRequest в браузере и экземпляр
    // http.ClientRequest в node.js
    log.error(`error at request`, config.message);
  } else {
    // Произошло что-то при настройке запроса, вызвавшее ошибку
    log.error(`error at settings`, config.message);
  }
}
